export function DiamondMark({ size = 28, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={`cg-diamond ${className}`}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="cgGrad" x1="0" y1="0" x2="48" y2="48">
          <stop offset="0%" stopColor="#5CC8F0" />
          <stop offset="55%" stopColor="#8C4FD6" />
          <stop offset="100%" stopColor="#F2B544" />
        </linearGradient>
      </defs>
      <path d="M24 2 L38 16 L24 46 L10 16 Z" stroke="url(#cgGrad)" strokeWidth="1.6" fill="rgba(140,79,214,0.14)" />
      <path d="M10 16 L38 16" stroke="url(#cgGrad)" strokeWidth="1.2" opacity="0.85" />
      <path d="M24 2 L24 46" stroke="url(#cgGrad)" strokeWidth="1" opacity="0.5" />
      <path d="M17 16 L24 46 L31 16" stroke="url(#cgGrad)" strokeWidth="1" opacity="0.6" />
    </svg>
  );
}
